import React from 'react'
import './index.css'
import request from '@/utils/request'
import { Input, Icon, Button, Form, DatePicker,message,Checkbox } from 'antd'
import { getToken, setToken, removeToken } from '@/utils/Cookie'
class instructionsTeam extends React.Component {
  state = {
    TimeNumber: 10,
    fn: null,
    isAgree: false,
    dataObjContent:null
  }
  componentWillMount() {
    this.getDates()
    // console.log(getToken())
    this.getDataInfo()
  }

  getDates = () => {
    var a = 10
    var Interval = setInterval(() => {
      if (a > 0) {
        a = a - 1
        this.setState({
          TimeNumber: a
        })
      } else {
        clearInterval(Interval)
      }
    }, 1000)
    this.setState({
      fn: Interval
    })
  }
  getDataInfo(){
    var that = this
    request
    .get('/v1/news?code=2')
    .then(res => {
       console.log('res')
      // console.log(res)
      // console.log(this.state.TimeArray)
      const data = res
      // for (var i = 0; i < this.state.IndexKey; i++) {
      //   ArrayData.unshift({})
      // }
      // console.log(ArrayData)
      console.log(data)
      this.setState({
        dataObjContent: data
      })
    })
  }
  componentWillUnmount() {
    clearInterval(this.state.fn)
  }
  GetPerson() {
    if (this.state.isAgree == true) {
      if (getToken()) {
        this.props.history.push('/Main/Team/TeamAppointment')
      } else {
        this.props.history.push('/Main/Team/LogoTeam')
      }
    } else {
      message.error('请先勾选同意条款按钮！')
    }

    // if (getToken()) {
    //   this.props.history.push('/Main/Team/TeamAppointment')
    // } else {
    //   this.props.history.push('/Main/Team/LogoTeam')
    // }
  }
  CheckChange = e => {
    // console.log(e)
    // console.log(`checked = ${e.target.checked}`)
    this.setState({
      isAgree: e.target.checked
    })
  }
  render() {
    const { TimeNumber, isAgree,dataObjContent } = this.state
    return (
      <div className="instructions">
        <div className="instructions_name">团队预约隐私条款</div>
        <div className="instructions_content_row" dangerouslySetInnerHTML={{__html:dataObjContent}}>
       </div>
        <div className="instructions_footer">
          <div className="instructions_footer_agree">
            <Checkbox onChange={this.CheckChange} checked={isAgree}>
              同意条款
            </Checkbox>
          </div>
          <div
            className="instructions_footer_button"
            onClick={el => this.GetPerson()}
          >
            我已阅读，立即订票
            {/* {TimeNumber > 0 ? (
              <span style={{ marginLeft: '5px' }}>{TimeNumber}s</span>
            ) : null} */}
          </div>
        </div>
      </div>
    )
  }
}
export default instructionsTeam
